import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';
import { Observable } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Issue, SafetyJobListedit, TaskPlan, Topic } from '../models';
import { BaseServices } from './../../kuba.services';
import { ApprovalNotice } from './../models/approval';
import { HttpClient, HttpContext } from '@angular/common/http';

@Injectable()
export class JobAnalysisService {
  _issueType: Observable<any> = null!;

  constructor(private http: HttpClient) { }
  clearCachedIssuesType() {
    this._issueType = null!;
  }
  getAll(id: number) {
    return this.http
      .get(environment.BASE_URL + '/riskanalysisbyproject/' + id).pipe(rxjsmap(result => result));
  }
  getAllByEach(id: number, key: string) {
    return this.http
      .get(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/safetyjobanalysis/listByBusiness/${BaseServices.BusinessId}/${id}`
      ).pipe(rxjsmap((result: any) => result));
  }

  getAllApproved(featureKey: number, key: string) {
    return this.http
      .get(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/safetyjobanalysis/approvalList/${BaseServices.BusinessId}/${featureKey}`
      ).pipe(rxjsmap(result => result));
  }

  getSafetyLog(id: number) {
    return this.http
      .get(environment.BASE_URL + '/safetyjobanalysislog/' + id).pipe(rxjsmap(result => result));
  }

  create(newSafetyJob: SafetyJobListedit, key: string) {
    return this.http
      .post(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/safetyjobanalysis`,
        newSafetyJob
      ).pipe(rxjsmap(result => result));
  }

  getIssueType(id: number) {
    return this.http
      .get(environment.BASE_URL + '/issuetype/' + id).pipe(rxjsmap(result => result));
  }
  getTopicList(id: number) {
    return this.http
      .get(environment.BASE_URL + '/DeviationTopic/' + id).pipe(rxjsmap(result => result));
  }

  // get all issues
  getAllIssues() {
    // BaseServices.BusinessId - businessid from r mode
    return this.http
      .get(
        environment.BASE_URL +
        '/issuetypes/' +
        BaseServices.BusinessId +
        '/' +
        BaseServices.roleId
      ).pipe(rxjsmap(result => result));
  }

  // add issue type dropdown
  createIssue(issueType: Issue) {
    return this.http
      .post(environment.BASE_URL + '/issuetype', JSON.stringify(issueType)).pipe(rxjsmap(result => result));
  }

  // edit issue type dropdowm
  updateIssue(issueType: Issue) {
    return this.http
      .put(environment.BASE_URL + '/issuetype/' + issueType.Id, issueType).pipe(rxjsmap(result => result));
  }

  // delete issue type dropdown
  deleteIssue(id: number) {
    let result: boolean;
    return this.http.delete(environment.BASE_URL + '/issuetype/' + id);
  }

  createTopic(newTopic: Topic) {
    return this.http
      .post(environment.BASE_URL + '/Save', JSON.stringify(newTopic)).pipe(rxjsmap(result => result));
  }

  updateTopic(updateTopic: Topic) {
    return this.http
      .put(environment.BASE_URL + '/Update', updateTopic).pipe(rxjsmap(result => result));
  }

  deleteTopic(id: number) {
    let result: boolean;
    return this.http.delete(environment.BASE_URL + '/Delete/' + id);
  }

  getUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id).pipe(rxjsmap(result => result));
  }

  addTaskPlan(newTaskPlan: any) {
    return this.http
      .post(environment.BASE_URL + '/RiskAnalysisTask', newTaskPlan).pipe(rxjsmap(result => result));
  }
  addSafetyJobAnalysis(task: any) {
    return this.http
      .post(environment.BASE_URL + '/foodsafety/safetyjobanalysis', task).pipe(rxjsmap(result => result));
  }
  updateTaskPlan(taskplan: TaskPlan) {
    return this.http
      .put(environment.BASE_URL + '/riskanalysistask', taskplan).pipe(rxjsmap(result => result));
  }
  updateFoodSafetTaskPlan(taskplan: TaskPlan) {
    return this.http
      .put(environment.BASE_URL + '/foodsafety/safetyjobanalysis', taskplan).pipe(rxjsmap(result => result));
  }
  getRiskById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/riskanalysis/' + id).pipe(rxjsmap((result: any) => result));
  }
  getByAnalysis(id: number) {
    return this.http
      .get(environment.BASE_URL + '/riskanalysistaskplan/' + id).pipe(rxjsmap(result => result));
  }

  getActivityById(id: any) {
    return this.http
      .get(environment.BASE_URL + '/activity/' + id).pipe(rxjsmap(result => result));
  }

  updateJobAnalysis(updateSafetyJob: any, key: string) {
    return this.http
      .put(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/safetyjobanalysis`,
        updateSafetyJob
      ).pipe(rxjsmap(result => result));
  }
  private extractData(res: any) {
    let body = res; // return body || {};
    return res;
  }

  deleteRiskAnanlysis(id: number) {
    let result: boolean;
    return this.http.delete(environment.BASE_URL + '/risanalysisdelete/' + id);
  }
  deleteTaskPlan(Id: any) {
    return this.http
      .delete(environment.BASE_URL + '/activitydelete/' + Id).pipe(rxjsmap(result => result));
  }
  deleteTaskPlanInRiskActvity(data: any) {
    return this.http
      .put(environment.BASE_URL + '/activitydeleteinriskactivity', data).pipe(rxjsmap(result => result));
  }
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  getCheckListData(businessId: number, featureId: number, featurekey: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/feature/checklist/GetAllCheckList/${businessId}/${featureId}/${featurekey}`
      ).pipe(rxjsmap(result => result));
  }

  /**
   * Makes an HTTP GET request to retrieve the checklists under completion in a module object.
   * @param featureId ID of the feature / module
   * @param featurekey ID / PK of the module object
   * @returns List of checklists under completion
   */
  getCompleteCheckListData(featureId: number, featurekey: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/features/FeatureManualComplete/getall/featurecompletechecklist/${featureId}/${featurekey}`
      ).pipe(rxjsmap(result => result));
  }

  deleteCompleteCheckListData(Id: any) {
    return this.http
      .put(
        environment.BASE_URL + '/features/FeatureManualComplete/delete/' + Id,
        {}
      ).pipe(rxjsmap(result => result));
  }

  deleteMultipleCompleteChecklist(data: any) {
    return this.http
      .put(
        environment.BASE_URL + '/features/FeatureManualComplete/delete/',
        data
      ).pipe(rxjsmap(result => result));
  }
  // Delete document
  deleteDocument(did: any) {
    return this.http
      .delete(`${environment.BASE_URL}/feature/delete/${did}`).pipe(rxjsmap(result => result)).pipe(rxjscatchError(error => BaseServices.handleError(error)));
  }

  checkExistingFunction(functionId: any) {
    return this.http
      .get(environment.BASE_URL + '/checkcase/' + functionId).pipe(rxjsmap(result => result));
  }
  checkforTopicexistingFunction(functionId: any) {
    return this.http
      .get(environment.BASE_URL + '/checktopicforrisk/' + functionId).pipe(rxjsmap(result => result));
  }

  reportGenerate(
    businessId: number,
    generateReportUnderFolder: any,
    userId: number,
    projectId: number,
    featureId: number,
    cultureInfo: string,
    ReportJson: any,
    appId: number,
    withApprovalStatus: any,
    context = new HttpContext()
  ): Observable<Blob> {
    const url = `${environment.BASE_URL}/export-SJAlist/${businessId}/${generateReportUnderFolder}/${userId}/${projectId}/${featureId}/${cultureInfo}/${appId}/${withApprovalStatus}`;
    return this.http.post(url, { data: ReportJson }, {
      responseType: 'blob',
      context
    });
  }
}
